import request from 'utils/request'
import { Message } from 'reducers/redirectReducer'

export const getMessageRequest = (apiData: Message) =>
  request({
    url: `/redirect/message`,
    method: 'get',
    params: apiData,
})